<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height overflow-auto"
      type="bar"
      :height="220"
      :raw-data="velocityZones"
      :chart-value-keys="[ { key: 'value', type: 'bar'} ]"
      :plot-options="{ bar: { horizontal: true, borderRadius: 4 } }"
      x-value="key"
      :grid="{ show: false }"
      :xaxis="{
        categories: velocityZones.map(stat => stat.label),
        tickPlacement: 'between',
        title: { text: $t('chart_legends.distance') },
        axisBorder: { show: false }
      }"
    >
      <template v-slot:header>
        <v-card-title class="pa-4">
          <v-row
            no-gutters
            align="center"
          >
            <v-col>
              <div
                class="subtitle-2 grey--text text--grey-100"
                style="word-break: normal"
              >
                {{ $t("card_title.velocity_zone_breakdown") }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
              </div>
            </v-col>
            <v-col
              cols="auto"
              class="ml-3 "
            >
              <v-btn
                v-if="removable"
                icon
                style="pointer-events: auto"
                @click="$emit('remove')"
              >
                <v-icon small>
                  fal fa-times
                </v-icon>
              </v-btn>
              <visual-list-toggle
                v-else
                :value.sync="viewMode"
              />
            </v-col>
          </v-row>
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-4">
        <v-row
          no-gutters
          align="center"
        >
          <v-col>
            <div
              class="subtitle-2 grey--text text--grey-100"
              style="word-break: normal"
            >
              {{ $t("card_title.velocity_zone_breakdown") }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
            </div>
            <v-col
              cols="auto"
              class="ml-3 "
            >
              <visual-list-toggle
                v-if="!removable"
                :value.sync="viewMode"
              />
            </v-col>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="velocityZones"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="220"
      >
        <template v-slot:item.label="{ item }">
          {{ item.label }}
        </template>
        <template v-slot:item.value="{ item }">
          {{ item.value }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'VelocityZoneChart',
  components: { LineChart, VisualListToggle },
  props: {
    stats: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    velocityZones() {
      return [
        { key: 'UXVELB67', label: this.$t('variables.zone6'), value: this.getStatValue('UXVELB67') || 0 },
        { key: 'UXVELB57', label: this.$t('variables.zone5'), value: this.getStatValue('UXVELB57') || 0 },
        { key: 'UXVELB47', label: this.$t('variables.zone4'), value: this.getStatValue('UXVELB47') || 0 },
        { key: 'UXVELB37', label: this.$t('variables.zone3'), value: this.getStatValue('UXVELB37') || 0 },
        { key: 'UXVELB27', label: this.$t('variables.zone2'), value: this.getStatValue('UXVELB27') || 0 },
        { key: 'UXVELB17', label: this.$t('variables.zone1'), value: this.getStatValue('UXVELB17') || 0 }
      ]
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.zone'),
          value: 'label',
          sortable: false,
          width: '60%'
        },
        {
          text: this.$t('table_headers.distance'),
          value: 'value',
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    getKeyWithAggregation(key) {
      return this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
    },
    getStatValue(key) {
      const aggregatedKey = this.getKeyWithAggregation(key)
      return this.stats[aggregatedKey]
    }
  }
}
</script>
